export default "__VITE_ASSET__8001fba7__"